import React from "react";
import Resources from "playground/cms/views/Resources";
import ListItem from "./ListItem";
import { ListLayout } from "playground/cms/List";
import { Search } from "playground/cms/List/Filter";
import IconButton from "components/IconButton";
import Popover from "components/Popover";
import SelectList, { SelectListItem } from "playground/ui/SelectList";
import { useApiActions } from "state/hooks";
import { renewCertificates, updateDomainInfo } from "cms/state/actions/domains";

//import PropTypes from 'prop-types';

function DomainListActions(props) {
    const { onUpdateInfo, onRenew } = useApiActions({
        onUpdateInfo: updateDomainInfo,
        onRenew: renewCertificates,
    });
    return (
        <Popover
            trigger={({ onClick }) => (
                <IconButton icon={"mui-settings"} onClick={onClick} />
            )}
            content={({ onClose }) => (
                <SelectList onClick={onClose}>
                    <SelectListItem onClick={() => onUpdateInfo()}>
                        Update info
                    </SelectListItem>
                    <SelectListItem onClick={() => onRenew()}>
                        Renew certificates
                    </SelectListItem>
                </SelectList>
            )}
        />
    );
}

export function Domains(props) {
    const { type } = props;
    return (
        <Resources {...props} ListItem={ListItem}>
            <ListLayout>
                <ListLayout.Filter>
                    <Search type={type} name={"search"} />
                </ListLayout.Filter>
                <ListLayout.Header>
                    <ListLayout.Header.Icons prepend={true}>
                        <ListLayout.Header.Filter />
                        <DomainListActions {...props} />
                    </ListLayout.Header.Icons>
                </ListLayout.Header>
            </ListLayout>
        </Resources>
    );
}

Domains.propTypes = {};

Domains.defaultProps = {};

export default Domains;
